import { BuyNowService } from '../services/buy-now.service';
import { Component, DoCheck, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ColCatService } from '../../shop/services/col-cat.service';
import { DetectScreenService } from '../../shop/services/detect-screen.service';
import { FirestoreProductsService } from '../services/firestore-products.service';
import { GlassImg } from '../interfaces/glass-img';
import { IntegerService } from '../services/integer.service';
import { MarbleImg } from '../interfaces/marble-img';
import { LocalStorageService } from '../services/local-storage.service';
import { Location } from '@angular/common';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { PricesService } from '../services/prices.service';
import { ProductRange } from '../interfaces/product-range';
import { ProductRangeService } from '../services/product-range.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { SteelImg } from '../interfaces/steel-img';
import tableCheck from './../../../assets/meta-data/table-types.json';
import { TopType } from '../interfaces/top-type';
import { TopTypeImg } from '../interfaces/top-type-img';
import { TopVariablesService } from '../services/top-variables.service';
import { TransformTextService } from '../services/transform-text.service';
import { Upholstery } from '../interfaces/upholstery';
import { UpholsteryImg } from '../interfaces/upholstery-img';
import { WoodImg } from '../interfaces/wood-img';

@Component({
  selector: 'app-single-product',
  styleUrls: ['./single-product.component.scss'],
  templateUrl: './single-product.component.html'
})

export class SingleProductComponent implements DoCheck, OnDestroy, OnInit {

  private basePosition: number;
  private categories: any[];
  private collections: any[];
  private collectionLength: number;
  private count: string;
  private countVal: string;
  private cost: number;
  private delivery: number;
  private depth: number;
  private discount: number;
  private evalMonth: boolean;
  private filteredProducts: any;
  private price: number;
  private firebasePositionTop: number;
  private isRectangleTable: boolean;
  private monthlyPrice: number;
  private months: string;
  private name: string;
  private openState: boolean;
  private products: ProductRange[];
  private prodCount: string;
  private routerVal: string;
  private subCategories: any[];
  private subCollections: any[];
  private tablePrice: number;
  private tablePriceDiscount: number;
  private tableSize: string;
  private topTypeList: TopType[];
  private totalCollectionCost: number;
  private variableProduct: boolean;
  private width: number;

  public area: string;
  public areaState: boolean;
  public buyState: boolean;
  public collection: string;
  public collectionChild: string;
  public isBaseUpholsteryGlass: boolean;
  public isBaseTable: boolean;
  public isBaseTableDining: boolean;
  public isBase: boolean;
  public isGlass: boolean;
  public isSingle: boolean;
  public isTableTop: boolean;
  public isTableTopDining: boolean;
  public isUphostery: boolean;
  public loop: number[];
  public monthEval: number;
  public ownDiscount: number;
  public productList: object;
  public productSelection: Observable<any>;
  public prodSelect: boolean;
  public renewDiscount: number;
  public screenWidth: number;
  public skuVal: string;
  public status: boolean;
  public subDetails: boolean;
  public subMenu: boolean;
  public subscription: Subscription;
  public tableTopSelection: string;
  public upholsterySelection: string;

  // private discount: number;
  private markup: number;
  private tax: number;

  // customize it my way properties
  public baseSelection: string;
  private baseType: string;
  private concreteTop: boolean;
  private glassImgList: GlassImg[];
  private glassTop: boolean;
  private glassSelection: string;
  private marbleImg: MarbleImg[];
  private marbleTop: boolean;
  private productId: string;
  private skuCat: string;
  private skuCatChild: string;
  private steelImgList: SteelImg[];
  private topCost: number;
  private topTypeImg: TopTypeImg[];
  private upholstery: string;
  private upholsterImg: UpholsteryImg[];
  private upholsteryList: Upholstery[];
  private woodImg: WoodImg[];
  private woodTop: boolean;

  @ViewChild('carousel') carousel: NgbCarouselConfig;

  constructor(
    private buyNow: BuyNowService,
    private config: NgbCarouselConfig,
    private colCatService: ColCatService,
    private detectScreen: DetectScreenService,
    private int: IntegerService,
    private location: Location,
    private pricesService: PricesService,
    private productRange: ProductRangeService,
    private fsProducts: FirestoreProductsService,
    private titleCaseService: TransformTextService,
    private topService: TopVariablesService,

    public ls: LocalStorageService,
    public router: Router
  ) {
    config.interval = 2500;
    config.pauseOnHover = true;
    config.showNavigationArrows = true;
    config.showNavigationIndicators = false;

    this.subscription =
      this.buyNow.getStatus().subscribe(status => this.buyState = status),
      this.ls.areaReturn().subscribe(boolean => this.areaState = boolean);

    this.catFilter();
    this.evalClasses();

    this.initPriceConstants();
    this.initCustomVals();
  }

  ngOnInit() {
    this.subscription =
      this.colCatService.getCollections().subscribe(data => this.collections = data),
      this.colCatService.subCollection().subscribe(data => this.subCollections = data),
      this.colCatService.category().subscribe(data => this.categories = data),
      this.colCatService.subCategory().subscribe(data => this.subCategories = data);

    this.subcribeArea();
    this.subcribeProduct();
    this.subcribeCount();
    this.subcribeMonth();

    this.ls.totalCounts();

    this.evalClasses();

    this.loop = [
      12, 11, 10, 9, 8, 7, 6, 5, 4, 3
    ];

    this.openState = false;

    this.setFilter();
  }

  ngOnDestroy() {
    this.filterBy('link', this.routerVal);
    this.subcribeCount();
    this.subcribeMonth();
    this.subscription.unsubscribe();
  }

  ngDoCheck() {
    this.prodSelect = this.ls.checkSelected(this.name);
  }

  private addToCart(): void {
    const checkLs = localStorage.productSelection;
    const checkMonth = localStorage.monthSelection;

    const inputVal = (<HTMLInputElement>document.getElementById(this.name)).value;

    console.log(inputVal);

    if (inputVal) {
      this.ls.countWrite(inputVal, this.name);
      // this.ls.nameWrite(this.name);
      if (checkLs === null) {
        this.ls.productWriteNew(this.name);
      } else {
        this.ls.productWrite(this.name);
      }

      if (this.prodCount === null || this.prodCount === undefined) {
        this.ls.countWrite('1', this.name);
      } else {
        this.ls.countWrite(this.prodCount, this.name);
      }

      // pass a month selection if the user hasn't selected already
      if (checkMonth === null || checkMonth === undefined) {
        this.ls.monthWrite('12');
      }

      this.prodSelect = this.ls.checkSelected(this.name);
      this.ls.totalCounts();
      this.generateSku();
      this.ls.productPrices(this.name, this.price);

      const prodTitleCase = this.getTitleCase(this.name);
      const prodCount = this.ls.getCount(this.name);

      swal.fire({
        background: '#f1f1f1',
        html: '<strong>' + prodCount + 'x ' + prodTitleCase + '</strong><br>has been added to your cart!',
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
        type: 'success'
      });
    }
  }

  private buyPriceDiscount(cost: number): number {
    const retailSellingPriceIncVat = this.pricesService.sellingPrice(cost, this.delivery, this.markup, this.tax);
    const monthlyPrice = this.monthPrice();
    return (this.sellingPrice() * (1 - (this.ownDiscount / 100))) - (monthlyPrice * this.monthEval);
  }

  public buyProduct(set: boolean): void {
    this.buyNow.setBuy(set);
  }

  private catFilter(): void {
    const tempVal: string[] = this.router.url.split('/');
    this.routerVal = tempVal[3];
    this.collection = tempVal[1];
    this.collectionChild = tempVal[2];
    if (this.collection === 'collections') {
      this.isSingle = false;
    } else {
      this.isSingle = true;
    }
  }

  public clearMonth(): void {
    const otherMonths = document.getElementsByClassName('month');
    for (let i = 0; i < otherMonths.length; i++) {
      otherMonths[i].classList.remove('selected');
    }
  }

  private evalClasses(): void {
    // tslint:disable-next-line: max-line-length
    if (this.collectionChild === 'accent-chairs' || this.collectionChild === 'chairs' || this.collectionChild === 'counter-bar-stools' || this.collectionChild === 'ottomans-benches' || this.collectionChild === 'sofas-sectional' || this.collectionChild === 'poufs-cubes' || this.collectionChild === 'floor' || this.collectionChild === 'pendants-chandeliers' || this.collectionChild === 'table' || this.collectionChild === 'wall' || this.collectionChild === 'floor-oversized') {
      this.isBaseUpholsteryGlass = true;
    } else {
      this.isBaseUpholsteryGlass = false;
    }

    // tslint:disable-next-line: max-line-length
    if (this.collectionChild === 'accent-side-tables' || this.collectionChild === 'coffee-tables' || this.collectionChild === 'consoles' || this.collectionChild === 'desks' || this.collectionChild === 'nesting-tables' || this.collectionChild === 'dining' || this.collectionChild === 'lounging') {
      this.isBaseTable = true;
    } else {
      this.isBaseTable = false;
    }

    if (this.collectionChild === 'bookcases-shelving') {
      this.isBase = true;
    } else {
      this.isBase = false;
    }

    // tslint:disable-next-line: max-line-length
    if (this.collectionChild === 'accent-side-tables' || this.collectionChild === 'coffee-tables' || this.collectionChild === 'consoles' || this.collectionChild === 'desks' || this.collectionChild === 'nesting-tables' || this.collectionChild === 'dining' || this.collectionChild === 'lounging') {
      this.isTableTop = true;
    } else {
      this.isTableTop = false;
    }

    if (this.collectionChild === 'dining-tables') {
      this.isTableTopDining = true;
      this.isBaseTableDining = true;
    } else {
      this.isTableTopDining = false;
      this.isBaseTableDining = false;
    }

    // tslint:disable-next-line: max-line-length
    if (this.collectionChild === 'floor' || this.collectionChild === 'pendants-chandeliers' || this.collectionChild === 'table' || this.collectionChild === 'wall' || this.collectionChild === 'floor-oversized') {
      this.isGlass = true;
    } else {
      this.isGlass = false;
    }

    // tslint:disable-next-line: max-line-length
    if (this.collectionChild === 'accent-chairs' || this.collectionChild === 'chairs' || this.collectionChild === 'counter-bar-stools' || this.collectionChild === 'ottomans-benches' || this.collectionChild === 'sofas-sectional' || this.collectionChild === 'poufs-cubes') {
      this.isUphostery = true;
    } else {
      this.isUphostery = false;
    }
  }

  private filterBy(key: string, value: string) {
    this.filteredProducts = this.fsProducts.filterBy(key, value).subscribe(document => {
      this.productRange.castBaseStamp(document);
      this.subscribeProductRange();
    });
  }

  private finishSelect(event) {
    const finishSelect = document.getElementsByClassName('finish');
    for (let i = 0; i < finishSelect.length; i++) {
      finishSelect[i].classList.remove('selected');
    }
    event.target.classList.add('selected');
  }

  private fixCat() {
    const fixCat = document.getElementsByClassName('fix-cat');
    let tempArray: string[];
    const capArray: string[] = [];
    for (let i = 0; i < fixCat.length; i++) {
      console.log(fixCat[i]);
      tempArray = fixCat[i].innerHTML.split(' ');
      console.log(tempArray);
    }
    console.log(tempArray);
    for (let i = 0; i < tempArray.length; i++) {
      capArray.push(tempArray[i].charAt(0).toUpperCase() + tempArray[i].slice(1));
      console.log(capArray);
    }
    for (let i = 0; i < fixCat.length; i++) {
      fixCat[i].innerHTML = capArray.join(' ');
    }
  }

  private generateSku(): void {
    this.skuVal = this.skuCat + '.' + this.skuCatChild + '.' + this.productId + '.' + this.baseType + '.' + (this.basePosition + 10001) + '.' + this.tableTopSelection + '.' + (this.firebasePositionTop + 10001);

    const arrayToSend: string[] = [
      'Base:' + this.baseType,
      'Top:' + this.upholsterySelection,
      this.tableTopSelection + ':' + this.upholsterySelection,
      'Seater:' + this.tableSize
    ]

    this.ls.selectionsWrite(this.name, this.name + '_' + arrayToSend.join('.'));
  }

  private getCollectionCosts(): void {
    this.productRange.productObs().subscribe((documents: any[]) => {
      // this.collectionLength = documents.length;
      const cost: number[] = [];
      for (let i = 0; i < documents.length; i++) {
        cost.push(documents[i].baseCost);
      }
      this.totalCollectionCost = cost.reduce((a, b) => a + b, 0);
      console.log('total collection cost: ' + this.totalCollectionCost);
      // this.getCosts();
    });
  }

  public getCount(name: string) {
    const returnVal = this.ls.getCount(name);
    if (returnVal) {
      return returnVal;
    } else {
      return '1';
    }
  }

  public getMonth(event): void {
    const dataVal: string = event.srcElement.dataset.indexNumber;
    event.srcElement.classList.add('selected');
    this.evalMonth = !this.evalMonth;
    this.ls.monthWrite(dataVal);

    const prodPrices = localStorage.getItem('productsPrice');
    if (prodPrices !== null || prodPrices !== undefined) {
      this.ls.priceWrite(prodPrices);
    }
  }

  private getProducts(): void {
    this.fsProducts.getProducts().subscribe(data => {
      // this.products = data;

      this.collectionLength = data.length;

      // Get Collection Cost
      let cost;
      let obj;
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        obj = data[i];
        cost = Object.values(obj)[i];
        total = total + obj.cost;
      }

      this.totalCollectionCost = total;
      // this.getCosts();
    });
  }

  private getTitleCase(string: string): string {
    return this.titleCaseService.newName(string);
  }

  private initCustomVals(): void {
    if (this.isRectangleTable === true) {
      this.depth = 900;
      this.width = 1200;
    } else {
      this.depth = 1200;
      this.width = 1200;
    }
  }

  private initLsValues(): void {
    if (localStorage.getItem('monthSelection')) {
      this.ls.monthWrite(localStorage.getItem('monthSelection'));
    } else {
      this.ls.monthWrite('12');
    }

    if (localStorage.getItem('areaSelection')) {
      this.area = localStorage.getItem('areaSelection');
      this.ls.areaWrite(this.area);
      this.ls.areaSend(true);
    }
  }

  private initPriceConstants(): void {
    this.screenWidth = this.detectScreen.getScreen();
    console.log('Screen width: ' + this.screenWidth);
    this.cost = 0;
    this.delivery = this.pricesService.delivery;
    this.discount = this.pricesService.discount;
    this.markup = this.pricesService.markup;
    this.monthEval = 0;
    this.ownDiscount = this.pricesService.ownDiscount;
    this.renewDiscount = this.pricesService.renewDiscount;
    this.tax = this.pricesService.taxVal;
  }

  private initSizeSelect(): void {
    this.firebasePositionTop = 0;
    this.topCost = this.pricesService.getCost(this.tableTopSelection);
    this.tablePrice = this.sellingPrice();
    console.log(this.tablePrice);
  }

  private initStates(): void {
    this.buyState = false;
    this.status = false;
    this.subDetails = false;
    this.subMenu = false;
  }

  private initSelections(): void {
    this.concreteTop = false;
    this.glassTop = true;
    this.marbleTop = false;
    this.woodTop = false;
    this.tableSize = '4-6';

    this.baseSelection = 'black';
    this.upholsterySelection = 'glass';
    this.tableTopSelection = 'clear';
    this.skuVal = this.skuCat + '.' + this.skuCatChild + '.' + this.productId + '.steel.10002.clear.10002';
  }

  private monthPrice(): number {
    if (this.monthEval > 0) {
      const retailPrice = this.sellingPrice();
      const correctCost = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, retailPrice);
      this.monthlyPrice = correctCost;
      return correctCost;
    }
  }

  public monthSub(month: number): number {
    const retailPrice = this.sellingPrice();
    const correctCost = this.pricesService.monthlySubscriptionPrices(this.discount, month, retailPrice);
    return correctCost;
  }

  private renewSub(month: number, cost: number): number {
    const retailPrice = this.sellingPrice();

    const retail = retailPrice * (1 - (this.pricesService.renewDiscount / 100));
    const correctCost = this.pricesService.monthlySubscriptionPrices(this.discount, month, retail);

    return correctCost;
  }

  private selectBase(event): void {
    this.baseSelection = event.srcElement.dataset.baseKey;
    this.generateSku();
  }

  private selectOption(event): void {
    function removeActive(domClass, className): void {
      if (event.srcElement.classList.contains(className) === true) {
        for (let i = 0; i < domClass.length; i++) {
          domClass[i].classList.remove('selected');
        }
      }
    }

    removeActive(document.getElementsByClassName('base'), 'base');
    removeActive(document.getElementsByClassName('glass'), 'glass');
    removeActive(document.getElementsByClassName('glass-top'), 'glass-top');
    removeActive(document.getElementsByClassName('marble'), 'marble');
    removeActive(document.getElementsByClassName('size'), 'size');
    removeActive(document.getElementsByClassName('table-tops'), 'table-tops');
    removeActive(document.getElementsByClassName('upholstery'), 'upholstery');
    removeActive(document.getElementsByClassName('wood'), 'wood');

    event.target.classList.add('selected');

    const indexVal = event.srcElement.dataset.indexNumber;
    const myClass = (event.srcElement.className).split(' ')[1];

    if (myClass === 'base') {
      this.baseSelection = indexVal;
    }

    if (myClass === 'upholstery' || myClass === 'glass') {
      this.upholsterySelection = indexVal;
    }

    if (myClass === 'glass-top' || myClass === 'marble' || myClass === 'wood') {
      this.tableTopSelection = indexVal;
    }

    // SKU
    this.basePosition = parseFloat(event.srcElement.dataset.dbPosition);
    this.generateSku();
  }

  private selectTop(event): void {
    this.upholsterySelection = event.srcElement.dataset.indexNumber;
    this.firebasePositionTop = parseFloat(event.srcElement.dataset.dbPosition);
    const selectedTop: string = event.srcElement.dataset.indexNumber;

    if (selectedTop === 'concrete') {
      this.concreteTop = true;
      this.glassTop = false;
      this.marbleTop = false;
      this.woodTop = false;
    } else if (selectedTop === 'glass') {
      this.concreteTop = false;
      this.glassTop = true;
      this.marbleTop = false;
      this.woodTop = false;
    } else if (selectedTop === 'marble') {
      this.concreteTop = false;
      this.glassTop = false;
      this.marbleTop = true;
      this.woodTop = false;
    } else if (selectedTop === 'wood') {
      this.concreteTop = false;
      this.glassTop = false;
      this.marbleTop = false;
      this.woodTop = true;
    }

    const topSelection = document.getElementsByClassName(selectedTop);
    this.tableTopSelection = topSelection[0].getAttribute('data-index-number');
    // console.log(this.tableTopSelection);
    // this.firebasePositionTop = parseFloat(topSelection[0].getAttribute('data-db-position'));
    // console.log(this.firebasePositionTop);

    const checkArray: string[] = [
      'clear', 'dark', 'calacatta', 'carrara', 'emperador', 'statuary', 'black', 'bronze', 'chrome', 'concrete', 'glass', 'marble', 'wood', 'charcoal', 'cream', 'navy', 'white', 'ash', 'oak', 'pine'
    ];

    const imgToSet = document.getElementsByClassName('img-to-set');
    let imgUrl: string;
    let newUrl: string;
    let textToRemove: string;
    for (let i = 0; i < imgToSet.length; i++) {
      imgUrl = imgToSet[i].getAttribute('src');

      // check if new url contains variation keyword
      for (let j = 0; j < checkArray.length; j++) {
        if (imgUrl.indexOf(checkArray[j]) === -1) {
          // return new string
          newUrl = imgUrl.split('.')[0] + '-' + selectedTop + '.' + imgUrl.split('.')[1];
          imgToSet[i].setAttribute('src', newUrl);
        } else if (imgUrl.indexOf(checkArray[j]) > -1) {
          // cut out variation keyword first
          textToRemove = '-' + checkArray[j];
          imgUrl = imgUrl.replace(textToRemove, '');
          newUrl = imgUrl.split('.')[0] + '-' + selectedTop + '.' + imgUrl.split('.')[1];
          imgToSet[i].setAttribute('src', newUrl);
        }
      }
    }

    this.generateSku();
  }

  private selectTopType(event): void {
    this.tableTopSelection = event.srcElement.dataset.indexNumber;
    this.firebasePositionTop = event.srcElement.dataset.dbPosition;
    this.initSizeSelect();
  }

  private selectUpholster(event): void {
    this.upholsterySelection = event.srcElement.dataset.keyVal;
    console.log(this.upholsterySelection);
  }

  private sellingPrice(): number {
    if (this.collectionChild === 'dining-tables') {
      let depth = this.depth;
      let width = this.width;

      if (this.isRectangleTable === true) {
        if (this.tableSize === '4-6') {
          depth = 900;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 2000;
          width = 1000;
        } else if (this.tableSize === '8-10') {
          depth = 2750;
          width = 1200;
        }
      } else if (this.isRectangleTable === false) {
        if (this.tableSize === '4-6') {
          depth = 1200;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 1500;
          width = 1500;
        }
      }

      this.price = this.pricesService.tableSellingPrice(this.cost, this.delivery, depth, this.markup, this.isRectangleTable, this.tableSize, this.topCost, this.tax, width);

      // this.ls.productPrices(this.name, this.price);
      return this.price;
    } else if (this.collectionChild !== 'dining-tables') {

      this.price = this.price = this.pricesService.sellingPrice(this.cost, this.delivery, this.markup, this.tax);
      // this.ls.productPrices(this.name, this.price);
      return this.price;
    }
  }

  private setCount(event, name: string): void {
    const countVal: string = event.srcElement.value;

    if (countVal) {
      this.prodCount = countVal;
      if (this.prodSelect === true) {
        this.ls.countWrite(countVal, name);
        this.ls.productPrices(this.name, this.price);
      }
    }
  }

  private setFilter(): void {
    if (this.isSingle === true) {
      this.filterBy('name', this.routerVal);
    } else if (this.isSingle === false) {
      this.getProducts();
      this.filterBy('collectionChild', this.routerVal);
    }
  }

  private setImg(event): void {
    const mainImg = document.getElementById('mainImg') as HTMLImageElement;
    const imgUrl: string = event.srcElement.src;
    mainImg.src = imgUrl;
  }

  private sizeSelect(event): void {
    this.tableSize = event.srcElement.dataset.tableSize;
    this.topCost = this.pricesService.getCost(this.tableTopSelection);
    // this.tableSellingPrice(this.tableSize, topCost);

    this.generateSku();
  }

  public subcribeArea(): void {
    this.subscription = this.ls.areaListener().subscribe(area => {
      if (area) {
        this.area = area;
        console.log(area);
        // this.areaVal = Object.values(area);
      }
   });
  }

  public subcribeCount(): void {
    this.subscription = this.ls.countListener().subscribe(count => {
      // if (count) {
      //   this.count = Object.values(count)[0];
      // } else {
      //   this.count = '0';
      // }

      const countLs = localStorage.getItem('productCount');
      if (countLs === null || countLs === undefined) {
        console.log('no value');
      } else {
        const counts: string[] = countLs.split(' ');
        for (let i = 0; i < counts.length; i++) {
          const tempCount: string[] = counts[i].split('_');
          const countVal: string = tempCount[1];
          const idVal: string = tempCount[0];
          this.countVal = countVal;
          console.log(countVal);
          console.log(idVal);
        }
      }

   });
  }

  public subcribeMonth(): void {
    this.subscription = this.ls.monthListener().subscribe(month => {
      if (month) {
        this.monthEval = this.ls.filterInt(month);
        this.months = month;
      } else {
        this.monthEval = 12;
        this.months = '12';
        this.ls.monthWrite('12');
      }
   });
  }

  public subcribeProduct(): void {
    this.subscription = this.ls.productListener().subscribe(name => {
      if (name) {
        console.log('Current observable sku: ' + name);
      } else {
        console.log('Current observable sku: ' + name);
      }
    });
  }

  public subscribeProductRange(): void {
    this.productRange.productObs().subscribe((document: any[]) => {

      this.productList = document;
      // tslint:disable-next-line: prefer-const
      let total = 0;

      // Set Product Properties
      for (let i = 0; i < document.length; i++) {
        this.variableProduct = document[i].topVariable;
        this.cost = total + document[i].baseCost;
        this.name = document[i].name;
        this.skuCat = document[i].skuCat;
        this.skuCatChild = document[i].skuCatChild;
        this.productId = document[i].productId;
        this.baseType = document[i].baseType;
      }
      this.subscribeVariable();

      // get name for localStorage

      if (this.collection === 'tables') {
        for (let i = 0; i < tableCheck.rectangle.length; i++) {
          if (tableCheck.rectangle[i] === this.name) {
            this.isRectangleTable = true;
          } else {
            this.isRectangleTable = false;
          }
        }
      }

      // Generate sku
      this.basePosition = 0;
      this.fsProducts.getProducts().subscribe(products => {
        for (let i = 0; i < products.length; i++) {
          if (products[i].name === name) {
            this.basePosition = this.basePosition + i;
            return;
          }
        }
      });

      this.initStates();
      this.initLsValues();
      this.initSelections();
      this.initSizeSelect();

      this.getCollectionCosts();
      this.sellingPrice();
      this.monthPrice();
    });
  }

  public subscribeVariable(): void {
    this.topService.getDoc().subscribe(document => {
      this.glassImgList = document[2];
      this.marbleImg = document[3];
      this.steelImgList = document[5];
      // this.topTypeList = document[9];
      this.topTypeImg = document[10];
      // this.upholsteryList = document[11];
      this.upholsterImg = document[12];
      this.woodImg = document[13];
    });
  }

  public toggleOptions(): void {
    this.subDetails = !this.subDetails;
  }

  public toggleSub(): void {
    this.subMenu = !this.subMenu;
  }

  public toggleSubscribe(): void {
    this.status = !this.status;
  }
}
